/**
 * Smooth scroll (Lenis)
 *
 * Replaces the native wheel scroll with an eased, inertial scroll on every page
 * (1.2s, expo-out easing). Touch devices keep their native scroll, which is the
 * Lenis default. Nothing is initialised when the visitor prefers reduced motion.
 *
 * - autoToggle: Lenis pauses while a modal dialog (cart drawer, mobile menu, quick
 *   shop) is open. It is driven by the `html:has(dialog:modal) { overflow: hidden }`
 *   lock in elements.css and the overflow transition in smooth-scroll.css.
 * - allowNestedScroll: scrollable children (mega menu, filters, drawers) keep
 *   scrolling natively.
 * - stopInertiaOnNavigate: a click on a link stops the inertia so the page does
 *   not keep moving during the view transition.
 * - Anchor links are animated by Lenis, offset by the header height so the target
 *   is not hidden behind the sticky header (mirrors the native scroll-padding-top).
 *
 * The instance is exposed as window.CocoCici.lenis for other scripts (back-to-top).
 */
import { Lenis } from 'global-modules';

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

if (!reducedMotion.matches) {
  const lenis = new Lenis({
    duration: 1.2,
    easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    autoRaf: true,
    autoToggle: true,
    allowNestedScroll: true,
    stopInertiaOnNavigate: true,
  });

  window.CocoCici = window.CocoCici || {};
  window.CocoCici.lenis = lenis;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link || link.hash.length < 2) return;

    const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
    if (!target) return;

    event.preventDefault();

    const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height-full')) || 0;
    lenis.scrollTo(target, { offset: -headerHeight });
  });
}
